import { useState, useRef, useEffect } from 'react'
import { projects } from './data/projects'
import Fade from 'react-reveal/Fade'
import './projects.css'

const Projects = () => {
  const [animateAll, setAnimateAll] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    const node = containerRef.current

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimateAll(true)
          observer.disconnect() // Animate once, optional
        }
      },
      { threshold: 0.1 }
    )

    if (node) {
      observer.observe(node)
    }

    return () => {
      if (node) observer.unobserve(node)
    }
  }, [])

  return (
    <section className="projects" id="projects" ref={containerRef}>
      <h2 className="projects--title">Projects</h2>
      <div className="projects--grid">
        {projects.map((project, index) => (
          <Fade key={index}>
            <article className="project">
              <img
                className={`project__image ${animateAll ? "scroll-effect" : ""}`}
                style={{ display: project.isCarousel ? 'none' : 'block' }}
                src={project.photos[0]}
                alt={project.title}
              />
              <div
                className="project__image"
                style={{ display: project.isCarousel ? 'block' : 'none' }}
              >
                <img
                  className={`carousel__image ${animateAll ? "carousel-effect" : ""}`}
                  src={project.photos[0]}
                  alt={project.title}
                />
              </div>
              <div className="project__details">
                <h3 className="project--title">{project.title}</h3>
                <div className="project__details--description">{project.description}</div>
                <div className="project__technologies">
                  {project.technologies.map((technology, techIndex) => (
                    <div key={techIndex} className="project__technologies--item">{technology}</div>
                  ))}
                </div>
              </div>
            </article>
          </Fade>
        ))}
      </div>
    </section>
  )
}

export default Projects
